import { Injectable, inject } from '@angular/core';
import { CalendarsService, RepetitiveEventOptionsContext } from '@cue/calendars';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class RepetitiveEventsService {
  private calendarsService = inject(CalendarsService);
  private configService = inject(ConfigService);

  isEnabled(): boolean {
    return (
      this.configService.value.assistCreatingReccuringEventsEnabled && this.calendarsService.supportsRepetitiveEvents()
    );
  }

  getPolicy() {
    return this.calendarsService.getRepetitiveEventsPolicy();
  }

  getOptions(context: RepetitiveEventOptionsContext) {
    return this.calendarsService.getRepetitiveEventOptions(context);
  }
}
